import { useQueryClient } from '@tanstack/vue-query'

const PROSPECTS_QUERY_KEY = ['prospects-leads']

export function useProspectCache() {
  const queryClient = useQueryClient()

  /**
   * Update prospect dates in TanStack Query cache
   * @param {Object} updatedProspect - Prospect with updated dates
   */
  function updateProspectDates(updatedProspect) {
    if (!updatedProspect?.id) return

    queryClient.setQueryData(PROSPECTS_QUERY_KEY, oldData => {
      if (!oldData) return oldData

      return oldData.map(prospect =>
        prospect.id === updatedProspect.id
          ? {
              ...prospect,
              start_date: updatedProspect.start_date,
              expected_closing_date: updatedProspect.expected_closing_date
            }
          : prospect
      )
    })
  }

  /**
   * Update prospect chance_to_score in TanStack Query cache
   * @param {Object} updatedProspect - Prospect with updated chance_to_score
   */
  function updateProspectChanceToScore(updatedProspect) {
    if (!updatedProspect?.id) return

    queryClient.setQueryData(PROSPECTS_QUERY_KEY, oldData => {
      if (!oldData) return oldData

      return oldData.map(prospect =>
        prospect.id === updatedProspect.id
          ? {
              ...prospect,
              chance_to_score: updatedProspect.chance_to_score
            }
          : prospect
      )
    })
  }

  /**
   * Invalidate the prospects cache (forces refetch)
   */
  function invalidateProspects() {
    queryClient.invalidateQueries({ queryKey: PROSPECTS_QUERY_KEY })
  }

  return {
    PROSPECTS_QUERY_KEY,
    updateProspectDates,
    updateProspectChanceToScore,
    invalidateProspects
  }
}
